import { createSelector } from "reselect";
import { isCleanerSelector } from "../users/selectors";
import {
  getCleaningListToUserForDate,
  getCleaningListForDate
} from "../cleaning/selectors";

const getRooms = state => state.rooms.data;

export const getRoomById = id =>
  createSelector([getRooms], rooms => rooms.find(room => room.roomId === id));

export const getVisibleRooms = createSelector(
  [
    isCleanerSelector,
    getCleaningListToUserForDate,
    getCleaningListForDate,
    getRooms
  ],
  (isCleaner, userCleaningList, cleaningList, rooms) => {
    if (!isCleaner) {
      return rooms;
    }

    const cleaningListWithoutUserCleaning = cleaningList.filter(
      cleaning =>
        !userCleaningList.find(
          userCleaning => userCleaning._id === cleaning._id
        )
    );

    return rooms.filter(
      room =>
        userCleaningList.find(userCleaning =>
          userCleaning.rooms.find(
            cleaningRoom => cleaningRoom.roomId === room.roomId
          )
        ) ||
        !cleaningListWithoutUserCleaning.find(cleaning =>
          cleaning.rooms.find(
            cleaningRoom => cleaningRoom.roomId === room.roomId
          )
        )
    );
  }
);



// WEBPACK FOOTER //
// ./src/rooms/selectors.js